class FeaturedAddOn extends HTMLElement {
  constructor() {
    super();
    this.quantityInput = this.querySelector("quantity-input .quantity__input");
  }

  connectedCallback() {
    this.quantityInput.addEventListener("change", this.handleQuantityChange.bind(this));
  }

  handleQuantityChange(e) {
    const quantity = parseInt(e.target.value);
    const priceInput = this.querySelector('[name="price"]');
    const price = priceInput.value;
    const refId = this.dataset.refId;

    this.dispatchEvent(new CustomEvent("item-quantity-updated", {
      bubbles: true,
      detail: {
        quantity,
        price,
        refId
      }
    }));
  }
}

customElements.define('featured-add-on', FeaturedAddOn);
